export const ItemTypes = {
    PAWN: 'pawn'
}